import { Menu } from '../models/menu.model';

export enum MenuItemsEnum {
	PhotoCaptureDashboard = 10,
	PhotoComplianceDashboard = 20
}

export const menuItems = [
	new Menu(
		MenuItemsEnum.PhotoCaptureDashboard,
		`Photo Capture`,
		'/photo-capture',
		null,
		'find_in_page',
		null,
		null,
		false,
		0
	),
	new Menu(
		MenuItemsEnum.PhotoComplianceDashboard,
		`Photo Compliance`,
		'/photo-compliance',
		null,
		'photo',
		null,
		null,
		false,
		0
	),

];
